import React from 'react';
import { string as stringType, number } from 'prop-types';
import {
  params,
  arrayOf,
  string,
  fragment,
  shape,
  useDataModel,
  customType
} from '@thd-nucleus/data-sources';
import {
  Card, CardBody, CardMedia, Typography, Button
} from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';
import { getImageUrl } from '../utils';

export function CapabilitiesTile({
  componentId,
  componentClass,
  id,
  componentPosition
}) {
  const { data } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass
    }
  });
  const dataComponent = data?.component;
  let {
    description,
    link,
    title,
    cta,
    previewImage
  } = dataComponent || {};

  const imageSrcUrl = getImageUrl({
    damImage: previewImage
  });

  const { ref, clickID } = useImpression({
    data: {
      id: componentId,
      name: 'CapabilitiesTile',
      component: 'CapabilitiesTile',
      type: 'content',
      position: componentPosition,
      category: title?.replace(/\W+/g, '')
    },
  });

  return (
    <div
      className="sui-grid sui-h-full"
      key={id}
      data-component="CapabilitiesTile"
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
    >
      <Card>
        <CardMedia
          aspect="wide"
          src={imageSrcUrl}
          alt={title}
        />
        <Typography variant="h4" weight="display" color="primary">{title}</Typography>
        <CardBody>
          <Typography variant="body-base">{description}</Typography>
        </CardBody>
        <Button href={link} variant="secondary">{cta}</Button>
      </Card>
    </div>
  );
}

CapabilitiesTile.propTypes = {
  componentId: stringType.isRequired,
  componentClass: stringType,
  id: stringType,
  componentPosition: number
};

CapabilitiesTile.defaultProps = {
  componentClass: '',
  id: undefined,
  componentPosition: 0
};

CapabilitiesTile.displayName = 'Capabilities Tile';

CapabilitiesTile.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass').enum(['CapabilitiesTile']).isRequired(),
  }).shape({
    CapabilitiesTile: fragment().shape({
      link: string(),
      id: string(),
      componentName: string(),
      title: string(),
      description: string(),
      cta: string(),
      previewImage: shape({
        damContentSelector: shape({
          assetData: arrayOf(shape({
            selectedImageUrl: string()
          }))
        }),
        damDownloadedContent: shape({
          url: string()
        })
      }),
    }),
  }),
};
